import { DefaultButton, MessageBarType, PrimaryButton, TextField, Text, Panel, PanelType, Dialog, DialogFooter, DialogType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { ICreateUndoRequest, IProtocolEF } from '../../../../shared/interfaces';
import { RootState } from '../../../../store';
import ErrorUtilities from '../../../../shared/Utilities/errorUtilities';
import richiesteAnnullamentoService from '../../../../services/richiesteAnnullamento.service';

export interface UndoRequestPanelProps {
    loading?: boolean
    extraCssClass?: string
    undoRequestPanelIsOpen: boolean
    currentProtocolEF: IProtocolEF | undefined
    onUndoRequestPanelSubmit: () => void
    onUndoRequestPanelDismiss: () => void

}

type Props = UndoRequestPanelProps & RouteComponentProps

const UndoRequestPanel: React.FunctionComponent<Props> = (props) => {

    let [panelIsOpen, { setTrue: openUndoRequestPanel, setFalse: dismissUndoRequestPanel }] = useBoolean(props.undoRequestPanelIsOpen);

    let [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    let [messageBarType, setMessageBarType] = useState<MessageBarType>(MessageBarType.info)
    let [messageBarText, setMessageBarText] = useState<string>('')

    let [textAreaValue, setTextAreaValue] = useState<string>('');

    let [undoRequestSubmitBtnEnable, { setTrue: enableUndoRequestSubmitBtn, setFalse: disableUndoRequestSubmitBtn }] = useBoolean(false);
    let [undoRequestSubmitBtnText, setUndoRequestSubmitBtnText] = useState<string>('Invia richiesta');

    let [actionsLoader, { setTrue: showActionsLoader, setFalse: hideActionsLoader }] = useBoolean(false);
    let [confirmDialogIsOpen, setConfirmDialogIsOpen] = useState<boolean>(false);

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const selectCurrentProtocol = (state: RootState) => state.appNavigationReducer.protocol
    const currentProtocol = useSelector(selectCurrentProtocol);

    const selectCurrentUser = (state: RootState) => state.sessionReducer.currentUser
    const currentUser = useSelector(selectCurrentUser);



    useEffect(() => {
        if (textAreaValue !== '') {
            enableUndoRequestSubmitBtn();
        }
        else {
            disableUndoRequestSubmitBtn();
        }
    }, [disableUndoRequestSubmitBtn, enableUndoRequestSubmitBtn, textAreaValue]);



    const handleTextChange = (event, newValue) => {
        // se newValue è un oggetto ne estraggo il valore
        const updatedValue = newValue && typeof newValue === 'object' ? newValue.target.value : newValue;
        setTextAreaValue(updatedValue);
    };


    const undoRequestPanelDismiss = () => {
        props.onUndoRequestPanelDismiss();
    }

    const showConfirmDialog = () => {
        setConfirmDialogIsOpen(true);
    }

    const confirmDialogContentProps = {
        id: 'dialog',
        type: DialogType.normal,
        title: 'Conferma',
        closeButtonAriaLabel: 'Close',
        subText: "Vuoi richiedere l'annullamento del protocollo?",
    }

    const undoRequestConfirmDialogSubmit = () => {
        showActionsLoader();

        if (currentUor && currentProtocol && currentUser) {

            // definisco l'oggetto richiesta contenente la motivazione
            let createUndoRequest: ICreateUndoRequest = {
                motivazioneRichiesta: textAreaValue
            }

            richiesteAnnullamentoService.addUndoRequest(currentAoo!.id!, currentUor!.id!, currentProtocol.id!, createUndoRequest)
                .then(result => {
                    props.onUndoRequestPanelSubmit();

                },
                    error => {

                        let myArgumentException = ErrorUtilities.GetMyArgumentExceptionFromError(error);

                        if (myArgumentException && myArgumentException.showMessageInClientApp) {
                            setMessageBarType(MessageBarType.warning);
                            setMessageBarText(myArgumentException.message);
                        }
                        else {
                            setMessageBarType(MessageBarType.error);
                            setMessageBarText("Errore nell'invio della richiesta di annullamento");

                        }
                        showMessageBar();
                    }
                )
                .finally(() => {
                    hideActionsLoader();
                    setConfirmDialogIsOpen(false);
                });


        }


    }

    const undoRequestConfirmDialogDismiss = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        setConfirmDialogIsOpen(false);
    }


    const onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text={undoRequestSubmitBtnText}
                    onClick={showConfirmDialog}
                    disabled={!undoRequestSubmitBtnEnable}
                    id="confermaPanel"

                />
                <DefaultButton
                    onClick={undoRequestPanelDismiss}
                    text="Annulla"
                    id="annullaPanel"
                />
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>


            {panelIsOpen &&
                <>
                    <Panel
                        key='undoRequestPanel'
                        id='panel'
                        isLightDismiss
                        isOpen={panelIsOpen}
                        type={PanelType.custom}
                        customWidth={'800px'}
                        headerText="Richiesta di annullamento del protocollo"
                        focusTrapZoneProps={{                            isClickableOutsideFocusTrap: false,                            forceFocusInsideTrap: true,                        }}                        onDismiss={undoRequestPanelDismiss}
                        onRenderFooterContent={onRenderFooterContent}
                        // Stretch panel content to fill the available height so the footer is positioned
                        // at the bottom of the page
                        isFooterAtBottom={false}
                    >

                        <TextField label="Inserire la motivazione della richiesta di annullamento"
                            multiline
                            maxLength={500}
                            autoAdjustHeight={true}
                            required={true}
                            value={textAreaValue}
                            onChange={handleTextChange}
                        />

                        <Dialog
                            hidden={!confirmDialogIsOpen}
                            dialogContentProps={confirmDialogContentProps}
                        >
                            <DialogFooter>
                                <PrimaryButton onClick={undoRequestConfirmDialogSubmit} text="Conferma" id="confermaDialog" />
                                <DefaultButton onClick={undoRequestConfirmDialogDismiss} text="Annulla" id="annullaDialog" />
                            </DialogFooter>

                        </Dialog>

                    </Panel>

                </>
            }

        </React.Fragment>
    );
}

export default UndoRequestPanel;